import React, { useState, useEffect } from 'react';

const SlideBanner: React.FC = () => {
    const [currentSlide, setCurrentSlide] = useState(0);

    const slides = [
        {
            id: 1,
            title: "Những khoảnh khắc đẹp",
            subtitle: "Chia sẻ niềm vui cùng nhau",
            image: "/banner/1.jpg"
        },
        {
            id: 2,
            title: "Kỷ niệm tuyệt vời",
            subtitle: "Những khoảnh khắc quý giá",
            image: "/banner/2.jpg"
        },
        {
            id: 3,
            title: "Thời gian bên nhau",
            subtitle: "Những khoảnh khắc ngọt ngào",
            image: "/banner/3.jpg"
        }
    ];

    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentSlide((prev) => (prev + 1) % slides.length);
        }, 5000);

        return () => clearInterval(timer);
    }, [slides.length]);

    const goToSlide = (index: number) => {
        setCurrentSlide(index);
    };

    return (
        <div className="relative bg-gradient-to-r from-pink-custom-50 to-pink-custom-100 py-12">
            <div className="container mx-auto px-4">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-stretch">
                    {/* Banner bên trái */}
                    <div className="relative overflow-hidden rounded-lg shadow-xl h-96">
                        <div className="flex transition-transform duration-500 ease-in-out h-full" style={{ transform: `translateX(-${currentSlide * 100}%)` }}>
                            {slides.map((slide, index) => (
                                <div key={slide.id} className="w-full flex-shrink-0 h-full">
                                    <div className="relative h-full">
                                        <img
                                            src={slide.image}
                                            alt={slide.title}
                                            className="w-full h-full object-cover"
                                        />
                                        <div className="absolute inset-0 bg-black bg-opacity-40 flex items-center justify-center">
                                            <div className="text-center text-white">
                                                <h2 className="text-3xl font-bold mb-4">{slide.title}</h2>
                                                <p className="text-lg">{slide.subtitle}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>

                        {/* Navigation dots */}
                        <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex space-x-2">
                            {slides.map((_, index) => (
                                <button
                                    key={index}
                                    onClick={() => goToSlide(index)}
                                    className={`w-3 h-3 rounded-full transition-colors duration-200 ${index === currentSlide ? 'bg-white' : 'bg-white bg-opacity-50'
                                        }`}
                                />
                            ))}
                        </div>
                    </div>

                    {/* Thư tình bên phải */}
                    <div className="text-center lg:text-left flex items-center">
                        <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-8 shadow-lg border border-pink-200 w-full h-96 flex flex-col justify-center">
                            <div className="text-4xl mb-4">💌</div>
                            <h3 className="text-2xl font-bold text-pink-800 mb-4 leading-relaxed">
                                Gửi Hải Vân yêu dấu
                            </h3>
                            <div className="text-sm text-gray-700 leading-relaxed mb-4 space-y-2">
                                <p>
                                    Gửi Hải Vân của anh,
                                </p>
                                <p>
                                    Mỗi khi nhìn thấy em, trái tim anh lại rung động như lần đầu gặp gỡ.
                                    Nụ cười của em là ánh sáng soi đường cho anh .
                                </p>
                                <p>
                                    Anh yêu em nhiều lắm.
                                </p>
                                <p>
                                    Yêu em mãi mãi,
                                </p>
                            </div>
                            <div className="flex items-center justify-center lg:justify-start space-x-4 text-pink-600">
                                <span className="text-sm font-medium">Hồng Đức</span>
                                <span className="text-xl">💝</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SlideBanner; 